var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 397.4 397.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 198.7,
    y1: 112.4,
    x2: 198.7,
    y2: 284.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3de2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5881fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c513ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 198.8,
    y1: 162.8,
    x2: 198.8,
    y2: 234.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 198.7,
    y1: 0,
    x2: 198.7,
    y2: 397.4,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249,112.4h-100.6c-19.8,0-35.9,16.1-35.9,35.9v100.7c0,19.8,16.1,35.9,35.9,35.9h100.6c19.8,0,35.9-16.1,35.9-35.9v-100.6c0-19.9-16.1-36-35.9-36ZM198.8,252.6c-29.8,0-53.9-24.1-53.9-53.9s24.1-53.9,53.9-53.9,53.9,24.1,53.9,53.9c0,29.7-24.2,53.9-53.9,53.9ZM256.3,152c-5.9,0-10.8-4.8-10.8-10.8s4.8-10.8,10.8-10.8,10.8,4.8,10.8,10.8c0,5.9-4.9,10.8-10.8,10.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.8,
    cy: 198.7,
    r: 35.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.7,0h0C89,0,0,89,0,198.7h0c0,109.7,89,198.7,198.7,198.7h0c109.7,0,198.7-89,198.7-198.7h0C397.4,89,308.4,0,198.7,0ZM302.9,252.6c0,27.8-22.5,50.3-50.3,50.3h-107.8c-27.8,0-50.3-22.5-50.3-50.3v-107.8c0-27.8,22.5-50.3,50.3-50.3h107.8c27.8,0,50.3,22.5,50.3,50.3v107.8Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramCircle);
export default __webpack_public_path__ + "static/media/instagram-circle.aaf0122ce238b1d78b071f444f99c239.svg";
export { ForwardRef as ReactComponent };